<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="primary accent--text title font-weight-thin mb-5">
            {{ $t('project.page.project_details') }}
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="12">
                <v-switch
                  v-model="model.status"
                  dense
                  color="success"
                  :label="$t('project.page.placeholder.status')"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="model.name"
                  dense
                  outlined
                  type="text"
                  :label="$t('project.page.placeholder.name')"
                  :rules="[required]"
                />
              </v-col>

              <v-col cols="12" md="12">
                <v-textarea
                  v-model="model.description"
                  dense
                  outlined
                  type="text"
                  :label="$t('project.page.placeholder.desc')"
                  :rules="[required]"
                />
              </v-col>
              <v-col cols="12" md="12">
                <groups-drop-down
                  :init-groups="model.uids"
                  @select-item="selectProjects"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-menu
                  ref="start-date"
                  v-model="startDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="model.startDate"
                      :label="$t('project.page.placeholder.start_date')"
                      persistent-hint
                      prepend-icon="event"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="model.startDate"
                    no-title
                    @input="startDate = false"
                  />
                </v-menu>
              </v-col>
              <v-col cols="12" md="6">
                <v-menu
                  ref="end-date"
                  v-model="endDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="model.endDate"
                      :label="$t('project.page.placeholder.end_date')"
                      persistent-hint
                      prepend-icon="event"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="model.endDate"
                    no-title
                    @input="endDate = false"
                  />
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-divider class="mb-5" />
        <v-btn
          outlined
          rounded
          :disabled="!changesMade || actionButtonDisabled"
          :loading="isLoading"
          color="primary"
          class="mr-3"
          @click="save"
        >
          {{ actionButtonTitle }}
        </v-btn>

        <v-btn
          outlined
          rounded
          text
          :disabled="isLoading"
          @click="cancel"
        >
          {{ $t('generic.button.cancel') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { isEmpty } from "lodash";
import { mapActions } from "vuex";
import GroupsDropDown from "@/components/Common/GroupsDropDown.vue";

export default {
  components: {
    GroupsDropDown,
  },
  props: {
    dialog: {
      type: Boolean,
    },
  },
  data() {
    return {
      valid: true,
      isLoading: false,
      startDate: false,
      endDate: false,
      project: { },
      model: {
        description: "",
        status: "",
        startDate: "",
        endDate: "",
        name: "",
        uids: [],
      },
    };
  },
  computed: {
    changesMade() {
      return JSON.stringify(this.model) !== JSON.stringify(this.project);
    },
    isCreateMode() {
      return isEmpty(this.model.id);
    },
    actionButtonTitle() {
      return this.isCreateMode ? this.$t('generic.button.save') : this.$t('generic.button.update');
    },
    actionButtonDisabled() {
      return !this.valid || !this.model.name || !this.model.description // TODO check if this is required or not || !this.model.startDate || !this.model.endDate
    },
  },
  async mounted() {
    this.project = await this.fetchProjectById(this.$route.params.id)
    this.model = { ...this.project };
    this.$refs.form.resetValidation()
  },
  methods: {
    ...mapActions([
      "createProject",
      "updateProject",
      "fetchProjectById",
      "initGroups",
      "getSessionTenant",
    ]),
    endSaveUpdateAction() {
      setTimeout(() => {
        this.isLoading = false;
        this.$router.push({
          name: "projects",
        });
      }, 2000);
    },
    async save() {
      this.isLoading = true
      const actionPerformed = 'generic.action_performed.'.concat(this.isCreateMode ? 'created' : 'updated')

      const successMsg = this.$t('generic.message.success', [this.$t('entity.project'), this.$t(actionPerformed)])
      const errorMsg = this.$t('generic.message.error', [this.$t('entity.project'), this.$t(actionPerformed)])

      if (this.isCreateMode) {
        await this.createProject(this.model).then(() => {
          this.showSnackbar(successMsg, this.$t('generic.status.success'));
          this.endSaveUpdateAction();
        }).catch(() => {
          this.showSnackbar(errorMsg, this.$t('generic.status.error'));
        });
      } else {
        await this.updateProject(this.model).then(() => {
          this.showSnackbar(successMsg, this.$t('generic.status.success'));
          this.endSaveUpdateAction();
        }).catch(() => {
          this.showSnackbar(errorMsg, this.$t('generic.status.error'));
        });
      }
    },
    emitSave() {
      this.$emit("save-form", {
        ...this.model,
      });
      // This case is for when its the HeaderBarAction
      this.$emit("close-dialog", this.model.uid);
    },
    cancel() {
      this.$router.push({
        name: "projects",
      });
    },
    selectProjects(projectId) {
      if (projectId) {
        this.model.uid = projectId;
      }
    },
  },
};
</script>
